import {PolymerElement} from '@polymer/polymer/polymer-element.js';
import {html} from '@polymer/polymer/lib/utils/html-tag.js';
import template from './ns-checkbox.html';

/**
 * The ns-checkbox should be used for all checkboxes at nuskin. It can do lots of cool stuff
 *
 * <h1>Checkbox</h1>
 * <demo-snippet class="demoSnippet">
 *   <template>
 *     <ns-checkbox></ns-checkbox>
 *   </template>
 * </demo-snippet>
 *
 */
export class NsCheckbox extends PolymerElement {
    constructor() {
        super();
    }

    ready() {
        super.ready();
    }

    static get is() {
        return "ns-checkbox";
    }

    static get template() {
        let htmlElement = document.createElement('TEMPLATE');
        htmlElement.innerHTML = template;
        return htmlElement;
    }

    static get properties() {
        return {
            type: {
                type: String,
                value: "default"
            },
            checkboxName: {
                type: String,
                value: ""
            },
            id: {
                type: String,
                value: "checkboxID"
            },
            checked: {
                type: Boolean,
                value: false,
                notify: true,
                reflectToAttribute: true
            },
            label: {
                type: String,
                value: "Checkbox Label"
            },
            disabled: {
                type: Boolean,
                value: false,
                reflectToAttribute: true
            },
            /**
             * dirty flag for the checkbox
             */
            dirty: {
                type: Boolean,
                value: false,
                notify: true,
                reflectToAttribute: true
            }
        };
    }

    onTap(e) {
        e.preventDefault();
        this.toggleCheckbox();
    }

    toggleCheckbox() {
        if (this.disabled) return;
        
        if (!this.toggled) {
            this.origValue = this.checked;
            this.toggled = true;
        }
        this.checked = !this.checked;
        this.dirty = this.origValue !== this.checked;
        // TODO: this might be better done by duplicating the native change event instead of 'checked'
        this.dispatchEvent(new CustomEvent('checked', {detail: {checked: this.checked}}));
    }

    uncheck() {
        this.set('checked', false);
    }
}

customElements.define(NsCheckbox.is, NsCheckbox);
